module.exports = __webpack_public_path__ + "img/ethz-logo.44b19eb9.svg";